import './styles/where-to-buy.scss';

import MapsLocator, {
    IInstaller,
} from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/MapsLocator/MapsLocator';

import { Breadcrumb } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import { PageTitle } from '../components/Primitives';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import buttonArrow from '@progymedia/sbi-web-englander/src/images/englander-icons/Right-Arrow-Icon.svg';
import { graphql } from 'gatsby';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query {
        metadata: allProductsJson(
            filter: { code: { eq: "englander_trouver-detaillant" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    texte_1 {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        partnerDealers: allPartnerDealer {
            nodes {
                SBIAccountNumber
                id
                AccountName
                Phone
                Email
                ShippingStreet
                ShippingCity
                ShippingPostalCode
                ShippingState
                ShippingCountry
                Website
                fields {
                    Latitude
                    Longitude
                }
            }
        }
    }
`;

export default function WhereToBuy({ data }) {
    const { t } = useTranslation('pages');
    const { currentLocale } = usePageLocalization();
    const cms = data?.metadata?.nodes?.[0];
    const metadataAttributes = cms?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const partnerDealerNodes = data?.partnerDealers?.nodes;
    const pageTitle = cms?.title?.[currentLocale];
    const pageDesc = cms?.description?.[currentLocale];

    const partnersFactory = (partnersNodes: any): IInstaller[] => {
        return partnersNodes
            .filter((p) => p.fields.Latitude != '0' && p.Longitude != '0')
            .map(
                (partnersNode) =>
                    ({
                        id: partnersNode.id,
                        name: transformSpecialChar(partnersNode.AccountName),
                        phone: partnersNode.Phone,
                        email:
                            partnersNode.Email == 'null'
                                ? null
                                : partnersNode.Email,
                        street: partnersNode.ShippingStreet,
                        city: partnersNode.ShippingCity,
                        zipcode: partnersNode.ShippingPostalCode,
                        state: partnersNode.ShippingState,
                        country: partnersNode.ShippingCountry,
                        lng: parseFloat(partnersNode.fields.Longitude),
                        lat: parseFloat(partnersNode.fields.Latitude),
                        Website:
                            partnersNode.Website == 'null'
                                ? null
                                : partnersNode.Website,
                    } as IInstaller)
            );
    };

    // fonction temporaire, lorsque le champ accountName dans le dynamoDB sera réglé, effacer cette fonction
    const transformSpecialChar = (text: string): string => {
        return text
            .replace(/&amp;/g, '&')
            .replace(/&#x27;/g, "'")
            .replace(/&#x60;/g, '`');
        return text;
    };

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />
            <div className='where-to-buy container'>
                <Breadcrumb
                    elements={[
                        { link: '/', name: t('layout:appliance.home') },
                        {
                            link: '',
                            name: t('layout:header.where-to-buy'),
                        },
                    ]}
                />
                <PageTitle title={pageTitle} description={pageDesc} />
                <div className='row'>
                    <div id='primary'>
                        <MapsLocator
                            installers={partnersFactory(partnerDealerNodes)}
                            traduction={{
                                inputPlaceholder: t('where-to-buy.postcode'),
                                buttonLabel: t('where-to-buy.button-label'),
                                results: t('where-to-buy.results'),
                                noAddress: t('where-to-buy.no-address-result'),
                                noEmpty: t('where-to-buy.cannot-be-empty'),
                                textboxLabel:
                                    cms?.attributes?.texte_1?.values?.[0]?.[
                                        currentLocale
                                    ],
                            }}
                            buttonArrow={buttonArrow}
                            displayIcons={true}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    );
}
